// Colors for different types
export const TYPE_COLORS = {
  '21Day': { bg: 'bg-blue-500', border: 'border-blue-600', text: 'text-blue-600', label: '21天', hex: '#3b82f6' },
  '15Day': { bg: 'bg-emerald-500', border: 'border-emerald-600', text: 'text-emerald-600', label: '15天', hex: '#10b981' },
  'Referral': { bg: 'bg-purple-500', border: 'border-purple-600', text: 'text-purple-600', label: '转介绍', hex: '#a855f7' },
  'Xianyu': { bg: 'bg-amber-500', border: 'border-amber-600', text: 'text-amber-600', label: '闲鱼', hex: '#f59e0b' },
} as const;
